import React, { useState } from "react";
import {
  Box,
  List,
  Text,
  Flex,
  Skeleton,
  useColorMode,
  useDisclosure,
  IconButton,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  DrawerCloseButton,
  Image,
  Button,
  VStack,
  HStack,
  Divider,
  Icon,
} from "@chakra-ui/react";
import { HamburgerIcon } from "@chakra-ui/icons";
import { HiMenuAlt3 } from "react-icons/hi";
import { Link, useHistory } from "react-router-dom";
import {
  FaHeart,
  FaUser,
  FaArchive,
  FaAdjust,
  FaRegNewspaper,
  FaExclamationTriangle,
  FaUserTie,
} from "react-icons/fa";
import { useAuth, logout } from "../../auth";
import { useGoogleAuth } from "../common/google/GoogleAuthContext";
import { useUser } from "../userRole/UserContext";
import { useOTP } from "../AdminPanelAccess/OTPContext";
import SidebarItem from "./SidebarItem";
import logo from "../../assets/images/logo1.png";
import { ReactComponent as DonateWhiteIcon } from "../../assets/icons/donate-white.svg";
import { FaSuitcase, FaWallet } from "react-icons/fa";
import { ReactComponent as HomeIcon } from "../../assets/icons/home_house_icon.svg";
import { ReactComponent as ChatIcon } from "../../assets/icons/chat_fill_message_communication_icon.svg";
import { ReactComponent as TravelTrackerIcon } from "../../assets/icons/passport.svg";
import { ReactComponent as PackingListIcon } from "../../assets/icons/fluent_clipboard_task_list_icon.svg";
import { ReactComponent as BudgetPlannerIcon } from "../../assets/icons/budget.svg";
import { ReactComponent as ItineraryIcon } from "../../assets/icons/noun-travel-itinerary-4236219.svg";
// import { ReactComponent as DonateIcon } from "../../assets/icons/donate.svg";
import Translate from "../LanguageTranslation/Translate";
import SettingsMenu from "../common/SettingsMenu";
import AuthModal from "../AuthModal";

const MobileDrawerMenu = () => {
  const { colorMode, toggleColorMode } = useColorMode();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const history = useHistory();
  const [logged] = useAuth();
  const { resetOTP } = useOTP();
  const { authState } = useGoogleAuth();
  const { user, loading } = useUser();
  const [redirectPath, setRedirectPath] = useState("/ai-travel-planner");
  const {
    isOpen: isAuthModalOpen,
    onOpen: onAuthModalOpen,
    onClose: onAuthModalClose,
  } = useDisclosure();

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const isUserLoggedIn = logged || authState.isLoggedIn;

  const username = localStorage.getItem("username") || "";
  const email = localStorage.getItem("email") || "unknown@example.com";

  const logoutAndClear = () => {
    logout();
    const keysToRemove = [
      "username",
      "email",
      "perPage",
      "perPageFilter",
      "nPXg",
      "chat_messages",
      "conversation_id",
      "OTP_TOKEN",
      "profilepic",
      "selectedTab",
      "selectedTripPackingList",
      "selectedTripBudgetPlanner",
      "selectedCause",
    ];
    keysToRemove.forEach((key) => localStorage.removeItem(key));
    resetOTP();
    history.push("/home");
  };

  const role = user ? user.role : null;

  let navLinks = [];

  const openAuthModal = (redirectPath) => {
    onAuthModalOpen();
    setRedirectPath(redirectPath);
  };

  if (loading) {
    navLinks = [
      { to: "#", text: <Skeleton width="100px" height="20px" /> },
      { to: "#", text: <Skeleton width="100px" height="20px" /> },
      { to: "#", text: <Skeleton width="100px" height="20px" /> },
    ];
  } else if (isUserLoggedIn) {
    navLinks.push({
      to: "/ai-travel-planner",
      text: "Ask Ava",
      icon: HomeIcon,
    });
    navLinks.push({
      to: "/ai-travel-planner/chat",
      text: "Chat",
      icon: ChatIcon,
    });
    navLinks.push({
      to: "/ai-travel-planner/bucket-list",
      text: "Bucket List",
      icon: FaHeart,
    });

    navLinks.push({
      to: "/ai-travel-planner/ongoing-trip",
      text: "Ongoing Trip",
      icon: ItineraryIcon,
    });
    navLinks.push({
      to: "/ai-travel-planner/budget-planner",
      text: "Budget Planner",
      icon: FaWallet,
    });
    navLinks.push({
      to: "/ai-travel-planner/packing-list",
      text: "Packing List",
      icon: FaSuitcase,
    });
    navLinks.push({
      to: "/ai-travel-planner/travel-feed",
      text: (
        <Box position="relative" display="inline-block" width="auto">
          <Text display="inline">
            <Translate text="Travel Feed" />
          </Text>
          <Box
            position="absolute"
            top={-3} // Adjust to move "Beta" slightly above
            right={-10} // Adjust for horizontal position
            bg="blackAlpha.100" // Similar to the pink color in the image
            color="black"
            fontWeight="bold"
            fontSize="10px"
            px={2}
            py={0.5}
            borderRadius="lg"
            display="inline"
          >
            <Translate text="SOON" />
          </Box>
        </Box>
      ),
      icon: TravelTrackerIcon,
    });
  } else {
    navLinks.push({
      to: "/ai-travel-planner",
      text: "Ask Ava",
      icon: HomeIcon,
    });
    navLinks.push({
      to: "/ai-travel-planner/chat",
      text: "Chat",
      icon: ChatIcon,
    });

    navLinks.push({
      to: "/ai-travel-planner/bucket-list",
      text: "Bucket List",
      icon: FaHeart,
      onClick: () => openAuthModal("/ai-travel-planner/bucket-list"), // Open auth modal for non-authenticated users
    });
    navLinks.push({
      to: "/ai-travel-planner/ongoing-trip",
      text: "Ongoing Trip",
      icon: ItineraryIcon,
      onClick: () => openAuthModal("/ai-travel-planner/ongoing-trip"), // Open auth modal for non-authenticated users
    });
    navLinks.push({
      to: "/ai-travel-planner/budget-planner",
      text: "Budget Planner",
      icon: FaWallet,
      onClick: () => openAuthModal("/ai-travel-planner/budget-planner"), // Open auth modal for non-authenticated users
    });
    navLinks.push({
      to: "/ai-travel-planner/packing-list",
      text: "Packing List",
      icon: FaSuitcase,
      onClick: () => openAuthModal("/ai-travel-planner/packing-list"), // Open auth modal for non-authenticated users
    });
    navLinks.push({
      to: "/ai-travel-planner/travel-feed",
      text: (
        <Box
          position="relative"
          display="inline-block"
          width="auto"
          onClick={() => openAuthModal("/ai-travel-planner/travel-feed")} // Corrected onClick syntax
        >
          <Text display="inline">
            <Translate text="Travel Feed" />
          </Text>
          <Box
            position="absolute"
            top={-3} // Adjust to move "Beta" slightly above
            right={-10} // Adjust for horizontal position
            bg="#1A202C" // Background color for the Beta tag
            color="white"
            fontSize="10px"
            px={2}
            py={0.5}
            borderRadius="lg"
            display="inline"
          >
            <Translate text="SOON" />
          </Box>
        </Box>
      ),
      icon: TravelTrackerIcon,
    });
  }

  const popoverLinks = isUserLoggedIn
    ? [
        ...(role === "Admin" || role === "User" || role === "Creator" || role === "Business"
          ? [{ to: "/account", text: "My Account", icon: FaUser }]
          : []),
        ...(role === "Admin" || role === "User" || role === "Creator" || role === "Business"
          ? [
              {
                to: "/archive",
                text: "Archiving and Downloading",
                icon: FaArchive,
              },
            ]
          : []),
        // ...(role === "Admin" || role === "User" || role === "Creator" || role === "Business"
        //   ? [
        //       {
        //         to: "/switch-appearance",
        //         text: "Switch Appearance",
        //         icon: FaAdjust,
        //       },
        //     ]
        //   : []),
        // ...(role === "Admin" || role === "User" || role === "Creator" || role === "Business"
        //   ? [
        //       {
        //         to: "/subscriptions",
        //         text: "Subscriptions",
        //         icon: FaRegNewspaper,
        //       },
        //     ]
        //   : []),
        ...(role === "Admin" || role === "User" || role === "Creator" || role === "Business"
          ? [
              {
                to: "/report",
                text: "Report a Problem",
                icon: FaExclamationTriangle,
              },
            ]
          : []),
        ...(role === "Admin"
          ? [
              {
                to: "/admin/dashboard",
                text: "Admin Dashboard",
                icon: FaUserTie,
              },
            ]
          : []),
      ]
    : [];
  return (
    <Box>
      {/* <IconButton
        mt={1}
        icon={<HiMenuAlt3 />}
        aria-label="Open menu"
        size="sm"
        variant="outline"
        display={{ base: "inline-flex", md: "none" }}
        onClick={onOpen}
      /> */}
      <Icon
        as={HiMenuAlt3}
        mt={2}
        boxSize="6" // Or use w/h
        aria-label="Open Menu"
        transform="scaleX(-1)"
        cursor="pointer"
        display={{ base: "inline-flex", md: "inline-flex", lg: "none" }}
        onClick={onOpen}
      />
      <Drawer isOpen={isOpen} placement="left" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>
            <Link to="/home">
              <Image src={logo} height="23px" />
            </Link>
          </DrawerHeader>

          <DrawerBody pl={0} pr="32px">
            <List spacing={4}>
              {/* Navigation Links */}
              {navLinks.map((link, index) => (
                <SidebarItem
                  key={index}
                  icon={link.icon}
                  to={link.to}
                  label={link.text}
                  isOpen={isSidebarOpen}
                  ml={0}
                  onClick={link.onClick}
                />
              ))}

              {/* <Divider /> */}
              <Flex align="left" justifyContent="center" pt={4} mb={4}>
                {/* Logout Button */}
                {isUserLoggedIn ? (
                  <Button
                    onClick={logoutAndClear}
                    color="black"
                    bg="white"
                    borderRadius="md"
                    border="1px solid black"
                    _hover="none"
                    size="sm"
                    width="80%"
                  >
                    <Translate text="Logout" />
                  </Button>
                ) : (
                  <Button
                    onClick={onAuthModalOpen}
                    color="black"
                    bg="white"
                    borderRadius="md"
                    border="1px solid black"
                    _hover="none"
                    width="80%"
                    size="sm"
                  >
                    <Translate text="Sign in" />
                  </Button>
                )}
              </Flex>

              <Flex align="center" justifyContent="center" mb={4}>
                <Button
                  leftIcon={<DonateWhiteIcon width="24px" height="24px" />}
                  as={Link}
                  to="/offset-your-carbon-footprint"
                  bg="#286328"
                  color="white"
                  size="sm"
                  _hover="none"
                  width="80%"
                >
                  <Translate text="Contribute" />
                </Button>
              </Flex>
              <VStack spacing={0}>
                <Divider m={0} />
                <SettingsMenu showMobileDrawer={false} />
                <Divider m={0} />
                <Text color="#374155" fontSize="sm" mb={0} mt={4}>
                  © 2024-2025 NOMAD360™
                </Text>

                <HStack
                  display={{ base: "flex", md: "none" }}
                  justify="center" // ⬅️ horizontal centering
                  spacing={4}
                >
                  <Link
                    // color="#4B5563"
                    // fontSize="sm"
                    href="/policies/terms-of-service"
                  >
                    <Text fontSize="sm" mb={0}>
                      <Translate text="Terms of Service" />
                    </Text>
                  </Link>
                  <Divider
                    orientation="vertical"
                    h="15px" // height of the line
                    borderColor="gray.400"
                  />
                  <Link
                    // color="#4B5563"
                    // fontSize="sm"
                    href="/policies/privacy-policy"
                  >
                    <Text fontSize="sm" mb={0}>
                      <Translate text="Privacy Policy" />
                    </Text>
                  </Link>
                </HStack>
              </VStack>
            </List>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
      <AuthModal
        isOpen={isAuthModalOpen}
        onClose={onAuthModalClose}
        redirectPath="/home"
      />
    </Box>
  );
};

export default MobileDrawerMenu;
